/**
 * Absolute expiry of the stored access token (AB#6617), in ms since the epoch.
 *
 * `expires_in` is relative to when the token was issued, so on its own it
 * can't tell a tab that was left open overnight that its token ran out. Every
 * place that stores an access token also stores this, and every place that
 * drops the token drops this too. Sessions from before this key existed have
 * none, which means "unknown": no proactive re-authorize, the 401 path still
 * covers them.
 */
export const TOKEN_EXPIRES_AT_KEY = 'token_expires_at'

/**
 * Stores `token_expires_at` for a token that was just stored. Without a
 * positive `expires_in` the expiry is unknown, and a stale value from the
 * previous token is removed instead.
 */
export const storeTokenExpiry = (expiresIn: number | null | undefined): void => {
  const seconds = Number(expiresIn)
  if (Number.isFinite(seconds) && seconds > 0) {
    localStorage.setItem(TOKEN_EXPIRES_AT_KEY, (Date.now() + seconds * 1000).toString())
    return
  }
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
}

export const clearTokenExpiry = (): void => {
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
}

/** The stored absolute expiry, or `null` when unknown. */
export const readTokenExpiresAt = (): number | null => {
  const at = Number.parseInt(localStorage.getItem(TOKEN_EXPIRES_AT_KEY) ?? '', 10)
  return Number.isFinite(at) ? at : null
}
